export default __webpack_public_path__ + "img/inverse-plus-circle.5a94ca3d.svg";